import React from 'react';
import PropTypes from 'prop-types';

import Loader from '../Loader';
import ProtectedMedia from '../../Molecules/ProtectedMedia';
import {
	preventMediaContextMenu,
	subscribeMediaProtection,
	subscribeObscured,
} from '../../../shared/MediaProtection';

import './index.sass';

class Video extends React.Component {
	state = {
		loading: true,
		cache: null,
		protectionHidden: false,
		obscuredHidden: false,
	}

	componentDidMount() {
		this.unsubscribeProtection = subscribeMediaProtection((active) => {
			this.syncMediaHidden({ protectionActive: active });
		});
		this.unsubscribeObscured = subscribeObscured((active) => {
			this.syncMediaHidden({ obscuredActive: active });
		});
	}

	componentWillUnmount() {
		if (this.unsubscribeProtection) {
			this.unsubscribeProtection();
		}
		if (this.unsubscribeObscured) {
			this.unsubscribeObscured();
		}
	}

	syncMediaHidden({ protectionActive, obscuredActive } = {}) {
		const { protectedMedia } = this.props;
		const nextState = {};

		if (typeof protectionActive === 'boolean') {
			nextState.protectionHidden = Boolean(protectedMedia && protectionActive);
		}

		if (typeof obscuredActive === 'boolean') {
			nextState.obscuredHidden = Boolean(protectedMedia && obscuredActive);
		}

		this.setState(nextState);
	}

	componentDidUpdate(prevProps) {
		const { id: lastId, avoidCache: lastAvoidCache, protectedMedia: lastProtectedMedia } = prevProps
		const { id, avoidCache, protectedMedia } = this.props
		const { loading } = this.state

		if (lastProtectedMedia !== protectedMedia && !protectedMedia) {
			this.setState({ protectionHidden: false, obscuredHidden: false });
		}

		if (lastId && lastId !== id && !loading) {
			this.setState({
				loading: true
			})
		}

		if (!lastAvoidCache && avoidCache) {
			this.setState({
				cache: new Date().getTime()
			})
		}
	}

	render() {
		const { className, id, filename, alt, type, hasBorder, avoidCache, protectedMedia } = this.props;
		const { cache, loading, protectionHidden, obscuredHidden } = this.state;
		let videoSource = `${process.env.ROVERPIX_API}/api/v1/video/download/${id}/${filename}?size=${type}`;

		if (avoidCache) videoSource = `${videoSource}&cache=${cache}`

		const mediaHidden = protectionHidden || obscuredHidden;
		const showLoader = loading || mediaHidden;

		const video = (
			<video
				className={`Video Video--${type} ${className} ${hasBorder ? 'Video--hasBorder' : ''} ${loading ? 'Video--loading' : ''} ${mediaHidden ? 'Video--protection-hidden' : ''}`}
				src={mediaHidden ? undefined : videoSource}
				alt={alt}
				controls={!mediaHidden}
				controlsList="nodownload"
				disablePictureInPicture
				draggable={false}
				onContextMenu={preventMediaContextMenu}
				onLoadedData={() => this.setState({ loading: false })}
			/>
		);

		return (
			<ProtectedMedia enabled={protectedMedia}>
				{showLoader && (
					<Loader size={type === 'thumb' ? 'small' : 'medium'}/>
				)}
				{video}
			</ProtectedMedia>
		)
	}
}

Video.propTypes = {
	className: PropTypes.string,
	id: PropTypes.string.isRequired,
	filename: PropTypes.string.isRequired,
	alt: PropTypes.string,
	type: PropTypes.oneOf([
		'thumb', 'preview'
	]),
	hasBorder: PropTypes.bool,
	avoidCache: PropTypes.bool,
	isExtra: PropTypes.bool,
	protectedMedia: PropTypes.bool,
};

Video.defaultProps = {
	className: '',
	alt: 'Customer video',
	type: 'thumb',
	hasBorder: false,
	avoidCache: false,
	isExtra: false,
	protectedMedia: false,
};

export default Video;
